/*
 * Витрина библиотеки. Её стили — только раскладка: сами элементы приходят
 * из библиотеки такими, какими будут в кабинете. Ни одного цвета элемента здесь нет,
 * иначе витрина показывала бы не то, что примут.
 */

.page {
  min-height: 100%;
  background: var(--bg-workspace);
  color: var(--text-primary);
}

.bar {
  position: sticky;
  top: 0;
  z-index: var(--z-popover);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
}

.barTitle {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  text-wrap: pretty;
}

.barGroup {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
}

.barLabel {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-secondary);
}

.barSpacer {
  flex: 1 1 var(--space-4);
}

.intro {
  margin: 0;
  padding: var(--space-4) var(--space-4) 0;
  max-width: 900px;
  font-size: var(--font-size-md);
  line-height: 1.55;
  color: var(--text-brand);
  text-wrap: pretty;
}

.grid {
  display: grid;
  /* Колонки сами решают, сколько их влезет: витрину смотрят и на 1366, и на ноутбуке
     1024, и с телефона — отдельных точек перелома здесь не нужно. */
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 340px), 1fr));
  gap: var(--space-4);
  align-items: start;
  padding: var(--space-4);
}

/* Режим «колонка 360»: витрина сжимается до ширины телефона мастера. Это и есть
   проверка, что элементы переносятся, а не обрезаются. */
.narrow {
  grid-template-columns: 360px;
  justify-content: start;
}

.wide {
  grid-column: 1 / -1;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}

.note {
  margin: 0;
  font-size: var(--font-size-sm);
  line-height: 1.45;
  color: var(--text-secondary);
  text-wrap: pretty;
}

.caption {
  margin: 0;
  font-size: var(--font-size-2xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.09em;
  color: var(--text-secondary);
}

/*
 * Проверка в градациях серого. Требование ТЗ к статусам: если ряд читается только
 * в цвете, различение построено на одном канале и не годится. Здесь тот же ряд
 * значков прогоняется через обесцвечивание прямо на витрине, чтобы это было видно
 * на приёмке, а не осталось словами в документе.
 */
.grayscale {
  filter: grayscale(1);
}

/* Рамка телефона мастера — чтобы на витрине было видно, что полоса состояния
   на 360 переносит текст, а не обрезает его. */
.phone {
  width: 360px;
  max-width: 100%;
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: var(--mobile-frame-radius);
  background: var(--bg-workspace);
  box-shadow: var(--shadow-pop);
}

.phoneBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-3);
}

.stripes {
  display: flex;
  flex-direction: column;
}

.skeletonRow {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}

.checking {
  font-size: var(--font-size-md);
  color: var(--text-secondary);
}
